import { css } from "lit";

export const linkStyles = css`
  a {
    text-decoration: none;

    &[href]:hover {
      text-decoration: underline;
    }

    &:visited, &:link {
      color: inherit;
    }
  }
`

// All pages must be "full-screen": this way, we can put footer in the very end of the page.
export const pageStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

// Every card that floats over the page, like help cards and hover popovers, looks the same.
// The tint sets the card apart from both white pages and the grey header.
// Dividers inside the card use --fk-color-border, so they pick up the tint too.
export const popoverCardStyles = css`
  .popover-card {
    --fk-color-border: var(--sl-color-primary-200);
    background: var(--sl-color-primary-50);
    border: 1px solid var(--fk-color-border);
    border-radius: var(--sl-border-radius-medium);
    box-shadow: var(--sl-shadow-large);
  }
`;

export const docLinkStyles = css`
  a {
    text-decoration: none;

    &[href]:hover {
      text-decoration: underline;
    }

    &:visited, &:link {
      color: #0969da;
    }
  }
`